module.exports = __webpack_public_path__ + "img/sign_invoice.3c6e6fd4.svg";